import React, { useState, useEffect } from 'react';

const STORAGE_KEY = 'ss_cookie_consent';

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);
    const [showDetails, setShowDetails] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem(STORAGE_KEY)) {
            const timer = setTimeout(() => setVisible(true), 800);
            return () => clearTimeout(timer);
        }
    }, []);

    const accept = () => {
        localStorage.setItem(STORAGE_KEY, 'accepted');
        setVisible(false);
    };

    const decline = () => {
        localStorage.setItem(STORAGE_KEY, 'declined');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div
            className="fixed bottom-0 left-0 right-0 z-50"
            style={{ animation: 'slideUp 0.35s ease-out' }}
        >
            <style>{`
                @keyframes slideUp {
                    from { transform: translateY(100%); opacity: 0; }
                    to   { transform: translateY(0);    opacity: 1; }
                }
            `}</style>

            <div
                className="mx-auto max-w-6xl mb-4 mx-4 rounded-2xl shadow-2xl overflow-hidden"
                style={{
                    background: '#1a1a2e',
                    border: '1px solid rgba(255,255,255,0.1)',
                    margin: '0 16px 16px',
                }}
            >
                <div className="px-6 py-5">
                    <div className="flex flex-col md:flex-row md:items-start gap-4">

                        {/* Icon + text */}
                        <div className="flex items-start gap-4 flex-1 min-w-0">
                            <div
                                className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 mt-0.5"
                                style={{ background: 'rgba(233,69,96,0.2)' }}
                            >
                                <i className="fas fa-cookie-bite" style={{ color: '#e94560' }}></i>
                            </div>
                            <div className="min-w-0">
                                <h3 className="text-white font-bold text-sm mb-1">
                                    We use cookies &amp; similar technologies
                                </h3>
                                <p className="text-gray-400 text-xs leading-relaxed">
                                    We use essential cookies to keep you signed in and process payments securely.
                                    We also use analytics cookies to understand how you use Seller Source so we can improve it.
                                    {' '}
                                    {!showDetails && (
                                        <button
                                            onClick={() => setShowDetails(true)}
                                            className="underline text-gray-300 hover:text-white transition-colors"
                                        >
                                            Learn more
                                        </button>
                                    )}
                                </p>

                                {showDetails && (
                                    <div className="mt-3 space-y-2">
                                        {[
                                            { icon: 'fa-shield-alt',    color: '#27ae60', label: 'Essential',  desc: 'Authentication, session management, and Stripe payment processing. Always active.' },
                                            { icon: 'fa-chart-bar',     color: '#2980b9', label: 'Analytics',  desc: 'Page views and feature usage (anonymised). Helps us improve the product.' },
                                            { icon: 'fa-sliders-h',     color: '#8e44ad', label: 'Preferences',desc: 'Remembers your report settings and display choices across visits.' },
                                        ].map(c => (
                                            <div key={c.label} className="flex items-start gap-2.5">
                                                <i className={`fas ${c.icon} text-xs mt-0.5 flex-shrink-0`} style={{ color: c.color }}></i>
                                                <div>
                                                    <span className="text-xs font-semibold text-gray-300">{c.label}: </span>
                                                    <span className="text-xs text-gray-500">{c.desc}</span>
                                                </div>
                                            </div>
                                        ))}
                                        <button
                                            onClick={() => setShowDetails(false)}
                                            className="text-xs underline text-gray-500 hover:text-gray-300 mt-1"
                                        >
                                            Show less
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Buttons */}
                        <div className="flex flex-row md:flex-col gap-2 flex-shrink-0 md:items-end">
                            <button
                                onClick={accept}
                                className="px-5 py-2.5 rounded-xl font-bold text-white text-xs transition-all hover:opacity-90 whitespace-nowrap"
                                style={{ background: '#e94560' }}
                            >
                                <i className="fas fa-check mr-1.5"></i>Accept All
                            </button>
                            <button
                                onClick={decline}
                                className="px-5 py-2.5 rounded-xl font-semibold text-xs transition-all whitespace-nowrap"
                                style={{
                                    background: 'rgba(255,255,255,0.07)',
                                    border: '1px solid rgba(255,255,255,0.15)',
                                    color: '#aaa',
                                }}
                            >
                                Essential Only
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
